import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AssetListFilterSelectionService {
  public toggleSelection<T>(currentSelection: T[], value: T, onUpdate: (selection: T[]) => void): void {
    let newSelection: T[] = [...currentSelection];
    if (newSelection.includes(value)) {
      newSelection = newSelection.filter((item: T) => item !== value);
    } else {
      newSelection = [...newSelection, value];
    }
    onUpdate(newSelection);
  }

  public toggleAllSelection<T>(currentSelection: T[], allOptions: T[], onUpdate: (selection: T[]) => void): void {
    let newSelection: T[];
    if (currentSelection.length === allOptions.length) {
      newSelection = [];
    } else {
      newSelection = [...allOptions];
    }
    onUpdate(newSelection);
  }

  public toggleProjectSelection(
    projectId: string,
    selectedProjectIds: string[],
    onUpdate: (ids: string[]) => void
  ): void {
    this.toggleSelection(selectedProjectIds, projectId, onUpdate);
  }

  public toggleAllProjects(
    selectedProjectIds: string[],
    projectOptions: { id: string }[],
    onUpdate: (ids: string[]) => void
  ): void {
    const allProjectIds: string[] = projectOptions.map((p: { id: string }) => p.id);
    this.toggleAllSelection(selectedProjectIds, allProjectIds, onUpdate);
  }

  public toggleFocusSelection(
    focusValue: string,
    selectedFocusValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedFocusValues, focusValue, onUpdate);
  }

  public toggleAllFocus(
    selectedFocusValues: string[],
    focusOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedFocusValues, focusOptions, onUpdate);
  }

  public toggleTypeSelection(
    typeValue: string,
    selectedTypeValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedTypeValues, typeValue, onUpdate);
  }

  public toggleAllType(
    selectedTypeValues: string[],
    typeOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedTypeValues, typeOptions, onUpdate);
  }

  public toggleBetsSelection(
    betsValue: string,
    selectedBetsValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedBetsValues, betsValue, onUpdate);
  }

  public toggleAllBets(
    selectedBetsValues: string[],
    betsOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedBetsValues, betsOptions, onUpdate);
  }

  public toggleDurationSelection(
    durationValue: string,
    selectedDurationValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedDurationValues, durationValue, onUpdate);
  }

  public toggleAllDuration(
    selectedDurationValues: string[],
    durationOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedDurationValues, durationOptions, onUpdate);
  }

  public toggleFormatSelection(
    formatValue: string,
    selectedFormatValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedFormatValues, formatValue, onUpdate);
  }

  public toggleAllFormat(
    selectedFormatValues: string[],
    formatOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedFormatValues, formatOptions, onUpdate);
  }

  public toggleCategoriesSelection(
    categoriesValue: string,
    selectedCategoriesValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedCategoriesValues, categoriesValue, onUpdate);
  }

  public toggleAllCategories(
    selectedCategoriesValues: string[],
    categoriesOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedCategoriesValues, categoriesOptions, onUpdate);
  }

  public toggleInUseSelection(
    inUseValue: string,
    selectedInUseValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedInUseValues, inUseValue, onUpdate);
  }

  public toggleAllInUse(
    selectedInUseValues: string[],
    inUseOptions: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleAllSelection(selectedInUseValues, inUseOptions, onUpdate);
  }

  public toggleStatusSelection(
    statusValue: string,
    selectedStatusValues: string[],
    onUpdate: (values: string[]) => void
  ): void {
    this.toggleSelection(selectedStatusValues, statusValue, onUpdate);
  }

  public toggleAllStatus(
    selectedStatusValues: string[],
    statusOptions: { value: string }[],
    onUpdate: (values: string[]) => void
  ): void {
    const allStatusValues: string[] = statusOptions.map((item: { value: string }) => item.value);
    this.toggleAllSelection(selectedStatusValues, allStatusValues, onUpdate);
  }

  public toggleHiddenFilter(showHiddenOnly: boolean, onUpdate: (value: boolean) => void): void {
    onUpdate(!showHiddenOnly);
  }
}
